<template src="./home.html">

</template>

<script>
import EventiRecenti from '@/components/dialog/calendar/EventiRecenti.vue';

export default {

  components: {
    EventiRecenti
  },

  data: () => ({
    aggiornaEventi: 0,
  }),

  methods: {
    async init() {
      let resUpdate = await this.$i2kFunctions.checkUpdate(
        this.$load.getUrlUpdate()
      );

      if (resUpdate) this.$toast.update("E' disponibile una nuova versione");
    },

    apriAttivita() {
      this.aggiornaEventi += 1;
    },

  },

  mounted() {
    this.init();
  },
};
</script>
